import api from '@pray/shared/utils/api';

import type { SyncNowResponse } from './types';

export async function postSyncNow({ artistId, catalogId }: { artistId: string; catalogId: string }) {
  if (!artistId) throw new Error('Artist ID is required');
  if (!catalogId) throw new Error('Catalog ID is required');
  // Unwrap the backend envelope ({ responded_at, object, data }) one level — see getCatalogs.ts.
  const res = await api.executePostRequest<{ data: SyncNowResponse }>(
    `/web/studio/artists/${artistId}/catalogs/${catalogId}/sync`
  );
  return res.data.data;
}
